// the shell: the rail, the list columns, the palette, the bell, sign-in (R10-Q16).
export const shell = {
  // The places (the rail, the list columns, the palette's jumps).
  chat: "Chat",
  team: "Team",
  inbox: "Inbox",
  automations: "Automations",
  admin: "Admin",
  navMain: "Main",
  // The rail's foot: the person's menu.
  roleAdmin: "Admin",
  roleMember: "Member",
  meMenu: "Preferences and sign out",
  preferences: "Preferences",
  signOut: "Sign out",
  // Counts said for screen readers.
  mentionsOfYou_one: "{n} mention of you",
  mentionsOfYou_other: "{n} mentions of you",
  mentionsSr_one: "mention of you",
  mentionsSr_other: "mentions of you",
  unreadCount: "{n} unread",
  unread: "unread",
  // The Chat list.
  search: "Search or jump to…",
  newChat: "New chat",
  newChatTitle: "Start a new chat with Vantage",
  pinned: "Pinned",
  startedByEmail: "Started by email",
  show: "Show",
  recent: "Recent",
  archived: "Archived",
  select: "Select",
  yourArchivedChats: "your archived chats",
  noArchivedChats: "No archived chats. Archive one from its ⋯ menu.",
  archivedHowBack: "Send a message in one, or use Restore in its ⋯ menu, to bring it back.",
  yourChats: "your chats",
  chatsEmpty: "Your chats will show here.",
  otherChats: "Other chats",
  showMore: "Show more",
  // Select mode.
  chats_one: "{n} chat",
  chats_other: "{n} chats",
  chatsArchived_one: "{n} chat archived",
  chatsArchived_other: "{n} chats archived",
  chatsDeleted_one: "{n} chat deleted",
  chatsDeleted_other: "{n} chats deleted",
  couldntUnarchive: "Couldn't unarchive them.",
  couldntArchive: "Couldn't archive them.",
  chatsCouldntDelete: "The chats couldn't be deleted.",
  selectedChats: "Selected chats",
  tickChats: "Tick the chats to archive or delete.",
  archiveChats_one: "Archive {n} chat",
  archiveChats_other: "Archive {n} chats",
  deleteChats_one: "Delete {n} chat",
  deleteChats_other: "Delete {n} chats",
  deleteChatsQ_one: "Delete {n} chat?",
  deleteChatsQ_other: "Delete {n} chats?",
  deleteChatsBody:
    "Their messages, Vantage's answers, and the files and reports in them are erased. This can't be undone once the next few seconds pass.",
  alsoForget: "Also forget what Vantage learned about you there",
  // The Team list.
  couldntOpenConversation: "Couldn't open that conversation.",
  newDm: "New direct message",
  findSomeone: "Find someone",
  findSomeoneDots: "Find someone…",
  noOneMatches: "No one matches.",
  yourChannelsAndMessages: "your channels and messages",
  channels: "Channels",
  notInChannel: "You're not in a channel yet.",
  muted: "Muted",
  directMessages: "Direct messages",
  noDms: "No direct messages yet.",
  // The Inbox list.
  filterByType: "Filter by type",
  showOnly: "Show only",
  markAllRead: "Mark all read",
  inboxSub: "Started by Vantage, for you",
  showEverything: "Show everything again",
  inboxDidntLoad: "The Inbox didn't load",
  due: "Due {when}",
  loadMore: "Load more",
  // The Admin list.
  people: "People",
  teams: "Teams",
  memory: "Memory",
  feedback: "Feedback",
  auditLog: "Audit log",
  settings: "Settings",
  active: "Active",
  newCount: "{n} new",
  newNoAccess: "{n} new items have no access yet",
  // The palette.
  messages: "Messages",
  files: "Files",
  notes: "Notes",
  directMessage: "Direct message",
  newChatWithVantage: "New chat with Vantage",
  jumpTo: "Jump to",
  adminJump: "Admin: {page}",
  chatWithVantage: "Chat with Vantage",
  channel: "Channel",
  conversations: "Conversations",
  file: "File",
  teamNoteIn: "#{slug} · team note",
  teamNote: "Team note",
  teamNotes: "Team notes",
  searchOrJump: "Search or jump to",
  fromPerson: "From",
  fromAnyone: "From anyone",
  nameYou: "{name} (you)",
  inPlace: "In",
  anywhere: "Anywhere",
  date: "Date",
  fromDate: "From",
  toDate: "To",
  clear: "Clear",
  hasFile: "Has a file",
  clearFilters: "Clear filters",
  kind: "Kind",
  results: "Results",
  couldntSearch: "Couldn't search just now.",
  searching: "Searching…",
  nothingMatches: "Nothing matches.",
  // The bell.
  notifications: "Notifications",
  notificationsNew: "Notifications ({n} new)",
  yourNotifications: "your notifications",
  notificationsEmpty: "Nothing new. Mentions and replies show here.",
  now: "now",
  dismissNotification: "Dismiss notification",
  // The version, the connection bar.
  copyVersion: "Copy the version",
  versionCopied: "Version copied",
  reconnecting: "Reconnecting…",
  reconnectNow: "Reconnect now",
  // Someone's presence, typing.
  isOnline: "{name} is online",
  isAway: "{name} is away",
  isOffline: "{name} is offline",
  typingOne: "{name} is typing…",
  typingTwo: "{a} and {b} are typing…",
  typingMany: "Several people are typing…",
  // A team's colours, access levels.
  hueBlue: "Blue",
  hueTeal: "Teal",
  hueViolet: "Violet",
  huePink: "Pink",
  hueAmber: "Amber",
  hueGreen: "Green",
  hueGrey: "Grey",
  levelNone: "None",
  levelRead: "Read",
  levelWrite: "Write",
  levelManage: "Manage",
  // Sign-in.
  tagline: "Busy Cube's AI teammate",
  couldntReach: "Couldn't reach Vantage. Try again.",
  signIn: "Sign in",
  signInIntro: "Use your Busy Cube email and we'll send you a one-time link.",
  email: "Email",
  emailMeLink: "Email me a sign-in link",
  onlyAdded: "Only people an admin has added can sign in.",
  checkEmail: "Check your email",
  linkSent:
    "If {email} belongs to someone here, a sign-in link is on its way. It works once and expires in 15 minutes.",
  codeLabel: "On the installed app? Type the 6-digit code instead",
  signInWithCode: "Sign in with the code",
  resendLink: "Resend the link",
  sentAgainAt: "Sent again at {time}. Use the newest email.",
  differentEmail: "Use a different email",
  linkUsedTitle: "This link was already used",
  linkUsedBody: "Each sign-in link works once. Ask for a new one and use it within 15 minutes.",
  linkExpiredTitle: "This link has expired",
  linkExpiredBody: "Sign-in links last 15 minutes. Ask for a new one.",
  linkInvalidTitle: "This link doesn't work",
  linkInvalidBody: "It may have been copied only in part. Ask for a new one.",
  askNewLink: "Ask for a new link",
  signInToVantage: "Sign in to Vantage",
  linkReady: "Your link is ready. Tap Sign in to continue on this device.",
  // Pages that aren't the app's.
  pageNotFound: "Page not found",
  pageNotFoundBody: "That page doesn't exist, or it moved.",
  goHome: "Go home",
  somethingWentWrong: "Something went wrong",
  errorBody: "This page hit an error. Reloading usually fixes it; if it doesn't, tell an admin.",
  reload: "Reload",
  adminsOnly: "Admins only",
  adminsOnlyHeading: "Only admins can open this page",
  adminsOnlyBody: "Ask an admin if you need something changed here.",
  // Notifications on this device (push), the live connection.
  pushInsecure:
    "Notifications need a secure connection (https). Open Vantage EX at its https address to turn them on.",
  pushInstall:
    "On an iPad or iPhone, add Vantage EX to the Home Screen first (Share → Add to Home Screen), then open it from there and turn notifications on.",
  pushUnsupported: "This browser can't show notifications from Vantage EX.",
  pushNoKey: "Notifications aren't set up on this server yet. An admin can turn them on.",
  pushDenied:
    "Notifications are blocked for Vantage EX. Allow them in the browser's site settings, then try again.",
  pushDeniedIos:
    "Notifications are blocked for Vantage EX. On your iPhone or iPad, open Settings → Notifications → Vantage EX, turn on Allow Notifications, then try again.",
  pushDeniedAndroid:
    "Notifications are blocked for Vantage EX. Touch and hold the Vantage icon, tap App info → Notifications, turn them on, then try again.",
  noLongerIn: "You're no longer in {name}.",
};
